import { render, staticRenderFns } from "./main.vue?vue&type=template&id=5fc2fc2a&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc2fc2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc2fc2a')) {
      api.createRecord('5fc2fc2a', component.options)
    } else {
      api.reload('5fc2fc2a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=5fc2fc2a&scoped=true", function () {
      api.rerender('5fc2fc2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/landing-page/view/components/setting-contact/main.vue"
export default component.exports